import { useState } from "react";
import { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import HeaderWeeklyReport from "../../../../Components/ComponentsIndustry/HeaderWeeklyReport";
import Loading from "../../../../Components/Loading";
import { useReportWeeklyIndustry } from "../../../../providers/ReportWeeklyIndustry";
import { useUser } from "../../../../providers/UserContext";

import {
  Container,
  SizeContainer,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";

const WeeklyReportCommercial = () => {
  const { industry, jogo } = useUser()
  const { reportWeeklyIndustry, loading, fetchReportWeeklyIndustry, setReportWeeklyIndustry } = useReportWeeklyIndustry()
  const [key, setKey] = useState('andamento');

  useEffect(() => {
    setReportWeeklyIndustry({
      purchases: [],
      pcp: [],
      productions: [],
      salesInProgress: [],
      salesDone: []
    })
    if (!industry || !jogo) return
    fetchReportWeeklyIndustry()
  }, [industry, jogo])

  return (
    <Container>
      <SizeContainer>
        <HeaderWeeklyReport selected={["", "", "", "selection"]} />
        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : null
        }

        <Tabs
          style={{
            position: 'absolute',
            width: '100%',
            marginTop: 30,
            top: 290,
            justifyContent: 'center',
            paddingTop: 10,
          }}
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
          fill
        >
          <Tab eventKey="andamento" title="Em andamento">
            {!loading && reportWeeklyIndustry?.salesInProgress?.length === 0 ? (
              <RoundContainer style={{ justifyContent: 'center' }}>
                <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma venda.</p>
              </RoundContainer>
            ) : null
            }
            {reportWeeklyIndustry?.salesInProgress?.map((sale, index) => {
              return (
                <RoundContainer key={index}>
                  <H2RoundContainer>
                    RODADA {sale[0].rodada?.numero}
                    <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
                  </H2RoundContainer>
                  <ParagraphRoundContainer>
                    Venda de produtos
                    <img src="./images/partnership.svg" alt="partnership" />
                  </ParagraphRoundContainer>
                  <MainRoundContainer>
                    {sale?.map((item, index) => {
                      let imageURL = null
                      if (item?.vendaProd[0]?.produto.nome === "Peito de Frango") {
                        imageURL = "./images/chicken_pcp.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Coxa de Frango") {
                        imageURL = "./images/cut_chicken_pcp.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Linguiça Salsichão") {
                        imageURL = "./images/pig.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Batata Frita") {
                        imageURL = "./images/fries_pcp.svg"
                      }
                      return (
                        <div key={index}>
                          <img src={imageURL} />
                          <p>
                            Quantidade: {item?.vendaProd[0]?.quantidadeTotal}Kg
                            <br />
                            Valor: {item?.vendaProd[0]?.valorTotal}
                          </p>
                        </div>
                      )
                    })

                    }
                  </MainRoundContainer>
                </RoundContainer>
              )
            })

            }
          </Tab>
          <Tab eventKey="entregue" title="Entregue">
            {!loading && reportWeeklyIndustry?.salesDone?.length === 0 ? (
              <RoundContainer style={{ justifyContent: 'center' }}>
                <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma venda.</p>
              </RoundContainer>
            ) : null
            }
            {reportWeeklyIndustry?.salesDone?.map((sale, index) => {
              return (
                <RoundContainer key={index}>
                  <H2RoundContainer>
                    RODADA {sale[0].rodada?.numero}
                    <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
                  </H2RoundContainer>
                  <ParagraphRoundContainer>
                    Venda de produtos
                    <img src="./images/partnership.svg" alt="partnership" />
                  </ParagraphRoundContainer>
                  <MainRoundContainer>
                    {sale?.map((item, index) => {
                      let imageURL = null
                      if (item?.vendaProd[0]?.produto.nome === "Peito de Frango") {
                        imageURL = "./images/chicken_pcp.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Coxa de Frango") {
                        imageURL = "./images/cut_chicken_pcp.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Linguiça Salsichão") {
                        imageURL = "./images/pig.svg"
                      } else if (item?.vendaProd[0]?.produto.nome === "Batata Frita") {
                        imageURL = "./images/fries_pcp.svg"
                      }
                      return (
                        <div key={index}>
                          <img src={imageURL} alt="sausage_pcp" />
                          <p>
                            Quantidade: {item?.vendaProd[0]?.quantidadeTotal}Kg
                            <br />
                            Valor: {item?.vendaProd[0]?.valorTotal}
                          </p>
                        </div>
                      )
                    })

                    }
                  </MainRoundContainer>
                </RoundContainer>
              )
            })

            }

          </Tab>
        </Tabs>


        {/* <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/partnership.svg" alt="partnership" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <div>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/condiment.svg" alt="condiment" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/box.svg" alt="box" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/pig.svg" alt="pig" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
          </MainRoundContainer>
        </RoundContainer> */}
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportCommercial;
